// apps/app/src/features/chat/state/resources/getPaginatedChannelHistory.ts
import { api } from '@api'

export const getPaginatedChannelHistory = async (
  channelId: string,
  cursor: string | null,
  direction: 'older' | 'newer' = 'older'
) => {
  let query = api()
    .from('message')
    .select(`
      *,
      profile ( username, last_seen (updated_at) ),
      profile_private ( role ),
      message_reaction ( emoji, created_by, message_id )
    `)
    .eq('channel_id', channelId)
    .limit(61)

  if (direction === 'older') {
    query = query.order('created_at', { ascending: false })
    if (cursor) query = query.lt('created_at', cursor)
  } else {
    // Fetching newer messages (scrolling down from history)
    query = query.order('created_at', { ascending: true })
    if (cursor) query = query.gt('created_at', cursor)
  }

  const { data, error } = await query

  if (error) {
    console.error(error)
    throw new Error(error.message)
  }

  // Ensure chronological order for the UI
  return direction === 'older' ? (data ? data.reverse() : []) : data || []
}
